/**
 *
 * @param original
 * @returns New object with no shared refs
 */
export function deepClone(original: any) {
    return JSON.parse(JSON.stringify(original));
}

// This moves the date from source to target without overriding arrays. It also will not update arrays unless a change is detected
export function deepAssign(target: any, source: any) {
    let targetKeys = Object.keys(target ?? {});
    Object.keys(source).forEach((prop) => {
        if (!targetKeys.includes(prop)) {
            return;
        }
        let sourceField = source[prop];
        let targetField = target[prop];
        let isSourceArray = Array.isArray(sourceField);
        let isTargetArray = Array.isArray(targetField);
        if (isSourceArray !== isTargetArray) {
            return;
        }
        if (isSourceArray) {
            let targetArray = targetField as any[];
            let sourceArray = sourceField as any[];
            if (hasArrayChange(targetArray, sourceArray)) {
                arrayOverride(targetArray, sourceArray);
            }
        } else {
            target[prop] = sourceField;
        }
    });
}

export function arrayOverride<T>(target: T[], source: T[]) {
    target.splice(0, target.length, ...source);
}

// TODO any should use generic so that both can match
export function hasFieldChange(oldValue: any, newValue: any, isArray?: boolean) {
    let isChanged = false;
    if (isArray == null) {
        isArray = Array.isArray(oldValue);
    }
    if (isArray) {
        let oldArray = oldValue as any[];
        let newArray = newValue as any[];
        isChanged = hasArrayChange(oldArray, newArray);
    } else {
        isChanged = oldValue != newValue;
    }
    return isChanged;
}

export function hasArrayChange<T>(arrayA: T[], arrayB: T[]): boolean {
    let isChanged;
    if (!arrayA || !arrayB || arrayA.length !== arrayB.length) {
        isChanged = true;
    } else {
        isChanged = !arrayA.every((o) => arrayB.some((n) => n == o));
    }
    return isChanged;
}

export function hasObjectChange<T extends { [index: string]: any }>(oldObject: T, newObject: T): boolean {
    let hasChange = false;
    if (!oldObject != !newObject) {
        return true;
    }
    for (let prop of Object.keys(oldObject)) {
        let oldValue = oldObject[prop];
        let newValue = newObject[prop];
        hasChange = hasFieldChange(oldValue, newValue);
        if (hasChange) {
            break;
        }
    }
    return hasChange;
}
